import React from 'react';
import { X, Gift, Sparkles } from 'lucide-react';
import ConfettiAnimation from './ConfettiAnimation';

const PromoSuccessModal = ({ isOpen, onClose, promoCode, discount }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Confetti Animation */}
      <ConfettiAnimation />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 text-center transform transition-all">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Success Icon */}
        <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
          <Gift className="w-10 h-10 text-white" />
        </div>

        {/* Success Message */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2 flex items-center justify-center gap-2">
            <Sparkles className="w-6 h-6 text-yellow-500" />
            Congratulations!
            <Sparkles className="w-6 h-6 text-yellow-500" />
          </h2>
          <p className="text-gray-600 mb-4">
            Your promo code has been successfully applied!
          </p>

          {/* Promo Details */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
            <div className="text-sm text-green-800">
              <div className="font-semibold">Promo Code: {promoCode}</div>
              <div className="text-lg font-bold text-yellow-600 mt-1">
                You saved ₹{discount.toFixed(2)}!
              </div>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <button
          onClick={onClose}
          className="w-full bg-gradient-to-r from-yellow-500 to-yellow-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-yellow-600 hover:to-yellow-700 transition-all transform hover:scale-105"
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
};

export default PromoSuccessModal;
